import type { CinemaSeries } from '@/utils/cinemaData';

export type RankingPeriod = 'total' | 'month' | 'week' | 'latest' | 'creator';

export function rankingViews(series: CinemaSeries, period: RankingPeriod) {
  if (period === 'week') return series.weekViews;
  if (period === 'month') return series.monthViews;
  return series.views;
}

interface RankingPeriodTabsProps {
  value: RankingPeriod;
  onChange: (value: RankingPeriod) => void;
  labels: Record<RankingPeriod, string>;
  periods?: RankingPeriod[];
}

export default function RankingPeriodTabs({
  value,
  onChange,
  labels,
  periods = ['total', 'month', 'week'],
}: RankingPeriodTabsProps) {
  return (
    <div className="inline-flex h-9 flex-shrink-0 items-center rounded-md border border-background-800 bg-background-900 p-1" role="group">
      {periods.map((period) => (
        <button
          key={period}
          type="button"
          onClick={() => onChange(period)}
          aria-pressed={value === period}
          className={`h-7 min-w-[58px] rounded px-2.5 text-xs font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#F19744]/55 ${
            value === period
              ? 'bg-[#F19744] text-background-950'
              : 'text-foreground-400 hover:bg-foreground-50/8 hover:text-foreground-100'
          }`}
        >
          {labels[period]}
        </button>
      ))}
    </div>
  );
}
